module.exports = __webpack_public_path__ + "static/media/z&v5.66e1b6c6.jpg";